import { GenIcon } from '~/libs/icons/IconBase';

export const IconKakao = GenIcon(
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="21" cy="21" r="21" fill="#FEDE00" />
    <path
      d="M21.5012 10.4592C15.1481 10.4592 10 14.5283 10 19.5506C10 22.818 12.1814 25.6846 15.4558 27.2857C15.2157 28.1829 14.5842 30.5391 14.4583 31.0425C14.3022 31.6671 14.6867 31.6601 14.9384 31.4923C15.1365 31.3594 18.0893 29.3505 19.3641 28.4859C20.0562 28.5884 20.7694 28.642 21.4988 28.642C27.8495 28.642 33 24.5729 33 19.5506C33 14.5283 27.8519 10.4592 21.5012 10.4592Z"
      fill="#371D1E"
    />
  </svg>,
);

export const IconNaver = GenIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
    <path
      d="M42 21C42 9.40202 32.598 0 21 0C9.40202 0 0 9.40202 0 21C0 32.598 9.40202 42 21 42C32.598 42 42 32.598 42 21Z"
      fill="#03C75A"
    />
    <path
      d="M23.7298 21.5399L18.0498 13.3999H13.3398V28.5999H18.2698V20.4599L23.9498 28.5999H28.6598V13.3999H23.7298V21.5399Z"
      fill="white"
    />
  </svg>,
);

export const IconGoogle = GenIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">
    <path
      d="M42.5249 21.5249C42.5249 9.92692 33.1229 0.524902 21.5249 0.524902C9.92692 0.524902 0.524902 9.92692 0.524902 21.5249C0.524902 33.1229 9.92692 42.5249 21.5249 42.5249C33.1229 42.5249 42.5249 33.1229 42.5249 21.5249Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.5249 21.5249C41.5249 10.4792 32.5706 1.5249 21.5249 1.5249C10.4792 1.5249 1.5249 10.4792 1.5249 21.5249C1.5249 32.5706 10.4792 41.5249 21.5249 41.5249C32.5706 41.5249 41.5249 32.5706 41.5249 21.5249ZM21.5249 0.524902C33.1229 0.524902 42.5249 9.92692 42.5249 21.5249C42.5249 33.1229 33.1229 42.5249 21.5249 42.5249C9.92692 42.5249 0.524902 33.1229 0.524902 21.5249C0.524902 9.92692 9.92692 0.524902 21.5249 0.524902Z"
      fill="#D9D9D9"
    />
    <path
      d="M31.8634 21.7698C31.8634 21.0061 31.7949 20.2719 31.6676 19.5669H21.5249V23.7326H27.3207C27.0711 25.0788 26.3124 26.2194 25.1718 26.983V29.6852H28.6522C30.6886 27.8103 31.8634 25.0495 31.8634 21.7698Z"
      fill="#4285F4"
    />
    <path
      d="M21.5247 32.2944C24.4324 32.2944 26.8701 31.33 28.6519 29.6853L25.1714 26.9832C24.2072 27.6293 22.9736 28.0112 21.5247 28.0112C18.7198 28.0112 16.3457 26.1167 15.4987 23.5713H11.9009V26.3615C13.673 29.8811 17.3149 32.2944 21.5247 32.2944Z"
      fill="#34A853"
    />
    <path
      d="M15.4991 23.5712C15.2838 22.9251 15.1614 22.2349 15.1614 21.5251C15.1614 20.8153 15.2838 20.1251 15.4991 19.4789V16.6888H11.9013C11.172 18.1426 10.7559 19.7873 10.7559 21.5251C10.7559 23.2628 11.172 24.9077 11.9013 26.3615L15.4991 23.5712Z"
      fill="#FBBC04"
    />
    <path
      d="M21.5247 15.0391C23.1057 15.0391 24.5253 15.5824 25.6415 16.6494L28.7303 13.5606C26.8653 11.8229 24.4274 10.7558 21.5247 10.7558C17.3149 10.7558 13.673 13.169 11.9009 16.6887L15.4987 19.4789C16.3457 16.9334 18.7198 15.0391 21.5247 15.0391Z"
      fill="#E94235"
    />
  </svg>,
);

export const IconApple = GenIcon(
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="40" rx="20" fill="black" />
    <path
      d="M27.489 15.8187C27.375 15.9087 25.3625 17.0628 25.3625 19.6291C25.3625 22.5974 27.9234 23.6475 28 23.6735C27.9882 23.7375 27.5932 25.1116 26.6498 26.5118C25.8086 27.7439 24.9301 28.974 23.5937 28.974C22.2572 28.974 21.9133 28.1839 20.3705 28.1839C18.867 28.1839 18.3324 29 17.1099 29C15.8875 29 15.0345 27.8599 14.0538 26.4597C12.9178 24.8156 12 22.2613 12 19.8371C12 15.9487 14.4842 13.8865 16.9291 13.8865C18.2282 13.8865 19.3111 14.7546 20.1268 14.7546C20.9031 14.7546 22.1137 13.8345 23.5917 13.8345C24.1518 13.8345 26.1644 13.8865 27.489 15.8187ZM22.8901 12.1883C23.5013 11.4502 23.9337 10.4261 23.9337 9.40204C23.9337 9.26003 23.9219 9.11601 23.8963 9C22.9019 9.038 21.7187 9.67407 21.0053 10.5162C20.4452 11.1642 19.9224 12.1883 19.9224 13.2264C19.9224 13.3824 19.9479 13.5385 19.9597 13.5885C20.0226 13.6005 20.1248 13.6145 20.227 13.6145C21.1193 13.6145 22.2415 13.0064 22.8901 12.1883Z"
      fill="white"
    />
  </svg>,
);
